import {objectTransenum} from "#components/SForm/SFormElement/utils";
import { isNumber } from 'lodash'

export const financial = (x: string | number, forInput: boolean = false) => {
  if (forInput) {
    return `${x}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }
  if (isNaN(Number(x)) || x == undefined) {
    return typeof x === 'string' ? x : 0
  }
  x = "" + x
  return Number.parseFloat(x).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',')
}

export const financialToNumber = (x: string | number) => {
  if (typeof x === 'number') {
    return x;
  }

  if (typeof x !== 'string') {
    return null;
  }
  let newX = +(x.replace(/,/g, ''));
  if (isNaN(newX)) {
    return null;
  }
  return newX
}


// 枚举货币
export const currencyEnum = {
  rmb: '人民币',
  usd: '美元',
  eur: '欧元',
  gbp: '英镑',
  jpy: '日元',
  hkd: '港币',
  twd: '新台币',
  krw: '韩元',
  myr: "林吉特",
  sgd: '新加坡元',
}

export const currencyOptions = objectTransenum(currencyEnum);


export function priceFormat(priceInfo: {
  price: number,
  currency: string,
}) {
  let { price, currency } = priceInfo;
  // 数据可能是字符串，且被格式化过，例如：1,000.00
  // 转成数字
  if (typeof price === 'string') {
    price = financialToNumber(price);
  }

  if (isNaN(+price)) {
    return '--'
  }
  // 千分位分隔符，保留两位小数，如果是整数，不显示小数
  const priceStr = (+price)?.toFixed?.(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
  // currency小写
  const currencyStr = currencyEnum[currency?.toLowerCase()] || currencyEnum.rmb;
  return `${priceStr} ${currencyStr}`;
}

export function orderNum(orderIndex, index?) {
  if (isNumber(orderIndex) && !isNaN(orderIndex)) {
    return orderIndex + 1;
  }
  if (isNumber(index) && !isNaN(index)) {
    return index + 1;
  }
  return ''
}
